
import { React, useState } from 'react';
import { useForm } from 'react-hook-form';


import { AppBar, Box, Button, Container, Link, Grid, Paper, IconButton, Typography, TextField } from '@mui/material';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';


export default function SignUp(){
    const { register, handleSubmit, formState: { errors }} = useForm();

    // const [goodSignup, setGoodSignup] = useState(false);
    // const [apiMessage, setApiMessage] = useState(" "); 

    const onFormSubmit = (formData) => {
        console.log(formData);

        //call api using fetch api

        fetch("http://localhost:3002/api/register", {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({'UserId': formData.Uid, 'Password': formData.Pwd})
        })
        .then((res) => res.json())
        .then((data) => { 
            
            console.log(data.UserId);  
            console.log(data.Password);  
            console.log(data.UserId + " signed up");  

            window.location.href = 'http://localhost:3000/signin';

        });
    }

    return (

        <>
        <Box height={100} />

        <Box sx={{py:2}}>
            <Typography variant='h4'>Sign Up to RACL</Typography>
        </Box>

        <form onSubmit={handleSubmit(onFormSubmit)} sx={{backgroundcolor:'lime', width:80}}>

            <Card sx={{minWidth:275}} variant='outlined'>

                <CardHeader title='User Infomation'/>
                <CardContent>

                    <Grid container spacing={2} >
                        <Grid item xs={12} sm={2} />

                        <Grid item xs={12} sm={4}>
                            <Box textAlign="right" sx={{ pt:2}}>
                                <Typography>Username/Email: </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Box textAlign="left" sx={{ pb:1}}>
                                <TextField id="uid" label='Username' variant='filled' {...register("Uid")}> </TextField>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={2} />
                    </Grid>

                    <Grid container spacing={2} >
                        <Grid item xs={12} sm={2} />                        
                        <Grid item xs={12} sm={4}>
                            <Box textAlign="right" sx={{ pt:2}}>
                                <Typography>Password: </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                        <Box textAlign="left" sx={{ pb:1}}>
                            <TextField id="pwd" type="password" label='Password' variant='filled' {...register("Pwd")} > </TextField>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={2} />
                    </Grid>

                    <Box sx={{p:2}}>
                    <Button id='button-signup' type="submit" color="primary" variant='contained' size="large">Sign Up</Button>
                    </Box>

                </CardContent>

            </Card>

        </form>

        </>

    );
}